<template>
  <sl-tooltip :content="tooltipText" :disabled="!tooltipText || disabled" hoist :style="tooltipMaxWidthPx" :placement="tooltipPlacement">
    <mc-button :class="buttonCssClass" icon="icon-plus" :disabled="disabled" @click="emit('click')">
      <span>{{title}}</span>
    </mc-button>
  </sl-tooltip>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue';
import "@shoelace-style/shoelace/dist/components/tooltip/tooltip.js";
import McButton from '@/components/ui/McButton.vue';

interface IFilterButtonAddProps {
  disabled?: boolean;
  title?: string;
  tooltipMaxWidth?: number;
  tooltipPlacement?: string,
  tooltipText?: string;
  useDefaultCssStyles?: boolean;
}

const props = withDefaults(defineProps<IFilterButtonAddProps>(), {
  disabled: false,
  title: 'Add',
  tooltipMaxWidth: 180,
  tooltipPlacement: 'bottom',
  useDefaultCssStyles: true
});

const { disabled, title, tooltipMaxWidth, tooltipPlacement, useDefaultCssStyles } = toRefs(props);

const tooltipMaxWidthPx = computed(() => `--max-width: ${tooltipMaxWidth.value}px;`);
const buttonCssClass = computed(() => useDefaultCssStyles.value ? 'brand-tertiary-button compact create-button' : 'filter-button-add');

const emit = defineEmits(["click"]);
</script>

<style>
:root {
  --filter-button-add-background-color: var(--colour-background-brand-hover);
  --filter-button-add-background-hover-color: var(--colour-background-brand-hover);
  --filter-button-add-text-color: var(--colour-text-brand-default);
  --filter-button-add-button-height: 24px;
  --filter-button-add-icon-font-size: 22px;
  --filter-button-add-text-color: var(--colour-text-brand-default);
  --filter-button-add-icon-color: var(--colour-text-brand-default);
}
</style>

<style scoped lang="scss">
.filter-button-add {
  --button-text-color: var(--filter-button-add-text-color);
  --button-background-color: var(--filter-button-add-background-color);
  --button-background-color-hover: var(--filter-button-add-background-hover-color);
  --button-height: var(--filter-button-add-button-height);
  --button-border-color: transparent;
  --button-border-focus: 1px solid transparent;
  --button-border-color-hover: transparent;
  --button-icon-font-size: var(--filter-button-add-icon-font-size);
  --button-icon-color: var(--filter-button-add-icon-color);

  padding-left: 4px;
  width: fit-content;
  gap: 3px;

  &:disabled {
    border: 1px solid var(--colour-border-neutral-default);
  }
}
</style>